import { ContentServiceAPI } from './ContentServiceAPI';
import { apiConfig } from '../../../utils/apiConfig';

export function useContentServiceAPI(): ContentServiceAPI {
  return new ContentServiceAPI(apiConfig);
}
